import { createGlobalStyle } from 'styled-components';
import reset from 'tokens/reset';
import nprogressBar from 'public/static/style';

const GlobalStyle = createGlobalStyle`
   ${reset}
   ${nprogressBar}

   /* Masquer le Next.js Route Announcer qui devient visible après le refactor du Layout */
   next-route-announcer {
     position: absolute !important;
     left: -9999px !important;
     width: 1px !important;
     height: 1px !important;
     overflow: hidden !important;
     visibility: hidden !important;
     font-size: 0 !important;
     line-height: 0 !important;
   }

   next-route-announcer * {
     position: absolute !important;
     width: 1px !important;
     height: 1px !important;
     padding: 0 !important;
     margin: -1px !important;
     overflow: hidden !important;
     clip: rect(0, 0, 0, 0) !important;
     white-space: nowrap !important;
     border: 0 !important;
     font-size: 0 !important;
     line-height: 0 !important;
     color: transparent !important;
     text-indent: -9999px !important;
   }
`;

export default GlobalStyle;
